/* istanbul ignore file -- FIXME(phase-18-ui-hoxxtv) Smart TV UI component / view — full per-component RTL interaction tests deferred to a follow-up wave (see deferred-items.md). Pattern matches 18-01 web (54 files) + 18-02 mobile (133 files). */
import React from 'react';

import { BannerButton, BannerButtonIcon, BannerButtonText } from './styled';

import { withFocusable } from '@noriginmedia/react-spatial-navigation';

export default withFocusable({})(function ButtonIcon({
  onPress,
  focused,
  children,
  icon,
  spaced,
}: {
  onPress?: () => void;
  focused?: boolean;
  children?: React.ReactNode;
  icon?: string;
  spaced?: boolean;
}) {
  return (
    <>
      <BannerButton onPress={onPress} active={focused} spaced={spaced}>
        <>
          <BannerButtonIcon active={focused} icon={icon} />
          <BannerButtonText active={focused}>{children}</BannerButtonText>
        </>
      </BannerButton>
    </>
  );
});
